import React      from 'react'; 
import portrait      from './portrait.module.css';
import landscape  from './bsb_300.module.css';
import Newspaper  from '../components/Newspaper.jsx';
import { Helmet } from 'react-helmet';

import pic_coming_soon from '../pictures/Comming soon-1.webp';
  
  

export class BSB300 extends React.Component
{
    //------------------------------------------------------------------
    //  Constructor
    //------------------------------------------------------------------
    constructor(props) 
    {
      super(props);
      this.component= "";
      this.state = {content_disabled: false}
    }  
    

    componentDidMount()
    {
      window.scrollTo({top:0, left: 0, behavious: 'smooth'});
    };
   
    //------------------------------------------------------------------
    //
    //------------------------------------------------------------------
    changeVisible(mode)
    {
      this.setState({content_disabled:mode})
    }

    //------------------------------------------------------------------
    //  Prepare the render output
    //------------------------------------------------------------------
    render()
    { 
      this.component = 
      <div className={landscape.backdrop} onMouseDown={()=>this.changeVisible(true)} onMouseUp={()=>this.changeVisible(false)} onContextMenu={(e) => e.preventDefault()}>
             <Helmet>
                  <title>BSB 300</title>
                  <meta name="description" content="The BSB 300 hardware is soon ready and will provide higher speed and network connection." />
                  <meta charset="utf-8" />
              </Helmet>

            <img src={pic_coming_soon} alt="picture coming soon" />
          
      </div>
    
      return this.component ;
    }
}  

